<template>
	<div>
		<div class="d-flex justify-content-between align-items-center mb-3">
			<div style="width: 40px;"></div>

			<h1 class="text-center flex-grow-1 m-0">Geräte Tabelle</h1>

			<button class="btn btn-primary" @click="showCreateModal = true">
				<i class="bi bi-plus"></i>
			</button>
		</div>
		<table class="table table-striped">
			<thead>
			<tr>
				<th>Gerät</th>
				<th>Alias</th>
				<th>Drucker</th>
				<th>Labeldrucker</th>
				<th>RFID-Drucker</th>
				<th>Infolabel-Drucker</th>
				<th>Bereichscode</th>
				<th>Version</th>
				<th>Letzes Update</th>
				<th></th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="device in devices" :key="device.id">
				<td>
					{{ device.name }}
				</td>
				<td>
					<click-to-edit-component
							v-model="device.alias"
							:dataId="device.id"
							dataPath="devicesettings/alias"
					/>
				</td>
				<td>
					<click-to-edit-component
							v-model="device.printer"
							:dataId="device.id"
							dataPath="devicesettings/printer"
					/>
				</td>
				<td>
					<click-to-edit-component
							v-model="device.labelPrinter"
							:dataId="device.id"
							dataPath="devicesettings/labelPrinter"
					/>
				</td>
				<td>
					<click-to-edit-component
							v-model="device.rfidPrinter"
							:dataId="device.id"
							dataPath="devicesettings/rfidPrinter"
					/>
				</td>
				<td>
					<click-to-edit-component
							v-model="device.infoLabelPrinter"
							:dataId="device.id"
							dataPath="devicesettings/infoLabelPrinter"
					/>
				</td>
				<td>
					<click-to-edit-component
							v-model="device.areaCode"
							:dataId="device.id"
							dataPath="devicesettings/areaCode"
					/>
				</td>
				<td> {{device.javaClientRelease ?? "-"}}</td>
				<td>{{ device.lastUpdate ? moment(device.lastUpdate).format('DD.MM.YYYY HH:mm') : '-' }}</td>
				<td>
					<b-btn @click="openDeleteModal(device.id)">
						<i class="bi bi-trash"></i>
					</b-btn>
				</td>
			</tr>
			</tbody>
		</table>
		<!-- Delete  Modal -->
		<b-modal
				v-model="showDeleteWarning"
				id="modal-warning-dialog"
				title="Gerät entfernen"
				centered
				no-close-on-backdrop
				no-close-on-esc
		>
			Möchten die Das Gerät <strong>{{ devices.find(d => d.id === deleteDeviceId)?.name }}</strong> wirklich entfernen?
			<template #modal-footer>
				<div class="w-100 d-flex justify-content-end">
					<div>
						<b-button
								size="md"
								class="mr-1 ml-2"
								variant="secondary"
								@click=" this.showDeleteWarning = false"
						>abbrechen
						</b-button>
						<b-button
								size="md"
								class="mx-1"
								variant="primary"
								@click="deleteDevice()"
						>löschen
						</b-button>
					</div>
				</div>
			</template>
		</b-modal>
		<!-- Create Modal -->
		<b-modal
				v-model="showCreateModal"
				id="modal-warning-dialog"
				title="Gerät hinzufügen"
				centered
				no-close-on-backdrop
		><!-- modal -->

			<div class="w-100">
				<b-form>
					<b-form-group label="Name" label-for="name">
						<b-form-input id="name" v-model="form.name" required></b-form-input>
					</b-form-group>

					<b-form-group label="Drucker" label-for="printer">
						<b-form-input id="printer" v-model="form.printer"></b-form-input>
					</b-form-group>

					<b-form-group label="Labeldrucker" label-for="labelPrinter">
						<b-form-input id="labelPrinter" v-model="form.labelPrinter"></b-form-input>
					</b-form-group>

					<b-form-group label="RFID-Drucker" label-for="rfidPrinter">
						<b-form-input id="rfidPrinter" v-model="form.rfidPrinter"></b-form-input>
					</b-form-group>

					<b-form-group label="Infolabel-Drucker" label-for="rfidPrinter">
						<b-form-input id="rfidPrinter" v-model="form.infoLabelPrinter"></b-form-input>
					</b-form-group>

					<b-form-group label="Bereichscode" label-for="areaCode">
						<b-form-input id="areaCode" v-model="form.areaCode"></b-form-input>
					</b-form-group>
				</b-form>
			</div>
			<template #modal-footer>
				<div class="w-100 d-flex justify-content-end">
					<b-button
							centered
							class="mr-1 ml-2"
							variant="secondary"
							@click="this.showCreateModal = false"
					>schliessen
					</b-button>
					<b-button
							centered
							size="md"
							class=" mx-1"
							variant="primary"
							@click="this.addDevice()"
					>speichern
					</b-button>
				</div>

			</template>
		</b-modal>
		<modal-error-component v-model="errorModal"></modal-error-component>
	</div>
</template>

<script>
import ModalErrorComponent from "./ModalErrorComponent.vue";

export default {
	name: "DeviceSettingsTable",
	components: {ModalErrorComponent},
	data() {
		return {
			devices: [],
			form: {
				name: '',
				printer: '',
				labelPrinter: '',
				rfidPrinter: '',
				infoLabelPrinter: '',
				areaCode: ''
			},
			fields: [
				{key: 'name', label: 'Gerät'},
				{key: 'printer', label: 'Drucker'},
				{key: 'labelPrinter', label: 'Labeldrucker'},
				{key: 'rfidPrinter', label: 'RFID-Drucker', sortable: false},
				{key: 'infoLabelPrinter', label: 'Infolabel-Drucker', sortable: false},
				{key: 'areaCode', label: 'Bereichscode', sortable: false},
				{key: 'splitRfidLabel', label: '?', sortable: false}
			],
			showCreateModal: false,
			showDeleteWarning: false,
			deleteDeviceId: null,
			errorModal: {
				show: false,
				message: '',
				error: null,
				title: 'Fehler beim Laden der Geräte',
			}
		};
	},
	methods: {
		addDevice() {
			axios.post('devicesettings', this.form).then(response => {
				this.devices.push(response.data);
				this.showCreateModal = false;
				this.form = {
					name: '',
					printer: '',
					labelPrinter: '',
					rfidPrinter: '',
					infoLabelPrinter: '',
					areaCode: ''
				};
				this.$bvToast.toast('Gerät erfolgreich hinzugefügt', {
					title: 'Erfolg',
					variant: 'success',
					autoHideDelay: 5000,
					solid: true
				});
				this.getAllDevices();
			}).catch(error => {
				this.errorModal.show = true;
				this.errorModal.message = 'Fehler beim speichern des Gerätes.';
				this.errorModal.error = error;
				console.error("Error adding device:", error);
			});
		},
		openDeleteModal(deviceId) {
			this.showDeleteWarning = true;
			this.deleteDeviceId = deviceId;
		},
		deleteDevice() {
			axios.delete('devicesettings/' + this.deleteDeviceId).then(response => {
				this.devices.push(response.data);
				this.showDeleteWarning = false;
				this.$bvToast.toast('Gerät erfolgreich gelöscht', {
					title: 'Erfolg',
					variant: 'success',
					autoHideDelay: 5000,
					solid: true
				});
				this.getAllDevices();
			}).catch(error => {
				this.errorModal.show = true;
				this.errorModal.message = 'Fehler beim speichern des Gerätes.';
				this.errorModal.error = error;
				console.error("Error adding device:", error);
			});
		},
		getAllDevices() {
			axios.get('devicesettings/all').then(response => {
				this.devices = response.data.sort((a, b) => a.name.localeCompare(b.name));
			}).catch(error => {
				this.errorModal.show = true;
				this.errorModal.message = 'Fehler beim Laden der Geräte.';
				this.errorModal.error = error;
				console.error("Error fetching devices:", error);
			});
		},
	},
	created() {
		this.getAllDevices();
	},
}
</script>

<style scoped>

</style>